import request from "../plugins/axios";

export function contactIndex(params) {
	return request({
		url: '/scrm/getContactList',
		method: 'GET',
		params
	})
}

export function batchCreateContactTag(data) {
	return request({
		url: '/workContactTag/batchCreateContactTag',
		method: 'PUT',
		data
	})
}

export function workRoom(params) {
	return request({
		url: '/workRoom/index',
		method: 'GET',
		params
	})
}

export function blackRoomList(params) {
    params.heiStatus = 0
	return request({
		url: '/scrm/getContactList',
		method: 'GET',
		params
	})
}

export function pendingReviewList(params) {
    params.examineStatus = 0
	return request({
		url: '/scrm/getContactList',
		method: 'GET',
		params
	})
}

export function repeatList(params) {
    return request({
        url: '/scrm/getRepeatList',
        method: 'GET',
        params
    })
}


export function disableContact(data) {
	return request({
		url: '/scrm/DisableContact',
		method: 'POST',
		data
	})
}

export function synchronizationRepeat(params) {
	return request({
		url: '/scrm/synchronizationRepeat',
		method: 'POST',
		params
	})
}

export function enableContact(data) {
	return request({
		url: '/scrm/EnableContact',
		method: 'POST',
		data
	})
}
export function reviewContact(data) {
    let param = {uid:data.contact_id}
    if (data.type) {
        return request({
            url: '/scrm/examineAgree',
            method: 'POST',
            data:param
        })
    } else {
        return request({
            url: '/scrm/examineRefuse',
            method: 'POST',
            data:param
        })
    }
}
export function updateContactRemark(data) {
	return request({
		url: '/scrm/userRemark',
		method: 'POST',
		data
	})
}